export class ClientDashboardDetailModel {
    constructor() {
        this.isAllStatesAssociated = false;
        this.associatedStates = [];
        this.mapStates = [];
    }
}
export default class ClientDashboardDetail extends ClientDashboardDetailModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
